import { createContext } from 'react'
import { ThemeState } from './Theme.types'

const initialState: ThemeState = {
  theme: 'light',
  updateTheme: () => null,
}

export const ThemeContext = createContext<ThemeState>(initialState)
